import { createContext, useContext } from 'react';
import { IStateReducer } from '../contextReducer/AppContextReducer';
import { IAppProviderState } from '../interface/IAppProvider';
import initialState from '../initialState/initialState';

export type TDispatch = (action: IStateReducer) => void;

export const AppDispatchContext = createContext<TDispatch | undefined>(undefined);

// The default values here, are not actually used, the constructor will set the actual vaules used.
export const AppStateContext = createContext<IAppProviderState>(initialState);

export function useGlobalState() {
    const context = useContext(AppStateContext);
    if (context === undefined) {
        throw new Error('useAppState must be used within a AppContextProvider');
    }
    return context;
}

export function useGlobalDispatch() {
    const context = useContext(AppDispatchContext);
    if (context === undefined) {
        throw new Error('useAppDispatch must be used within a AppContextProvider');
    }
    return context;
}
